import React, { useState } from 'react';
import classes from './Gaming.module.scss';
import useOffers from 'components/pages/Offers/useOffers';
import { GAMING_CATEGORIES } from 'constants/offerCategories';
import { PROMOTION_TAG } from 'utils/offers';
import { useDebounce } from 'hooks/useDebounce';
import OffersControls from 'components/molecules/OffersControls/OffersControls';
import OffersListingPage from 'components/pages/Offers/OffersListingPage';
import { useOfferCategoryNavigation } from 'components/pages/Offers/useOfferCategoryNavigation';
import { GAMING } from '../pages';
import { ListingProps } from '../Cashbacks/Cashbacks.qmee';

const Gaming: React.FC<ListingProps> = ({ selectedCategory: initialSelectedCategory }) => {
  const { listRef, handleCategorySelect, selectedCategory } =
    useOfferCategoryNavigation(initialSelectedCategory);

  const [searchQuery, setSearchQuery] = useState('');
  const debouncedSearchQuery = useDebounce(searchQuery);

  const { items, promoItem, categories } = useOffers({
    apiField: 'cashbacks',
    requiredTags: ['gaming'],
    paysReward: true,
    selectedCategory,
    basePath: GAMING.path,
    offerType: 'gaming',
    promoTags: [PROMOTION_TAG],
    customCategories: GAMING_CATEGORIES,
    searchQuery: debouncedSearchQuery,
  });

  return (
    <div className={classes.root}>
      <OffersControls
        categories={categories}
        selectedCategory={selectedCategory}
        onCategorySelect={handleCategorySelect}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        listRef={listRef}
      />

      <OffersListingPage
        items={items}
        promoItem={promoItem}
        categories={categories}
        searchQuery={searchQuery}
        selectedCategory={selectedCategory}
        onCategorySelect={handleCategorySelect}
        offerType="gaming"
      />
    </div>
  );
};

export default Gaming;
